import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import {
  ReadyToSeePossibilities,
  SharedHero,
} from '../../v2/components/common';
import Layout from '../../v2/components/common/layout/Layout';
import CaseStudies from '../../v2/components/renderings/case-studies';
import Info from '../../v2/components/renderings/info';
import RenderingsPersonalized from '../../v2/components/renderings/renderings-personalized/renderingsPersonalized';
import { URLS } from '../../v2/constants';

const Renderings: React.FC = () => (
  <Layout
    title="Renderings"
    description="With HOVER Renderings, you can bring design ideas to life with a beautifully rendered, photo-realistic vision."
    buttonType="CHAT_WITH_A_REP"
  >
    <SharedHero
      heading="High quality visualizations to close more jobs"
      body={`Bring design ideas to life with a beautifully rendered, photo-realistic vision that delights and excites your customers.\n\nHelp your customers see the potential in their properties while building trust and collaboration, quickly aligning on project scope, and closing more big-ticket jobs.`}
      chatWithUsLink={URLS.renderings.chatWithUs}
      openModalButtonTitle="TURN IT ON"
      openModalButtonLink={URLS.renderings.turnItOn}
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/renderings_hero_desktop.jpg"
          alt="renderings-hero"
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/renderings_hero_tablet.jpg"
          alt="exterior-contractors-hero"
        />
      }
    />

    <RenderingsPersonalized />
    <Info />
    <CaseStudies />
    <ReadyToSeePossibilities body="Whether you’re a small business, a national team, or somewhere in between, we can help." />
  </Layout>
);

export default Renderings;
